module.exports = __webpack_public_path__ + "static/media/img-bg-jackpot-header-front@3x.29555eb2.png";